import React, { ReactNode } from 'react';

import { Tooltip, TooltipProps } from '@mui/material';
import { SvgIconOwnProps } from '@infoods/lifebase-ui';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import classes from './InfoTooltip.module.scss';

type InfoTooltipProps = {
  children: ReactNode;
  iconFontSize?: SvgIconOwnProps['fontSize'];
  color?: SvgIconOwnProps['color'];
} & Pick<TooltipProps, 'placement' | 'arrow'>;

const InfoTooltip = ({
  children,
  placement = 'bottom',
  iconFontSize = 'small',
  color = 'tertiary',
  arrow = false,
}: InfoTooltipProps) => {
  return (
    <Tooltip
      slotProps={{
        tooltip: { className: classes.tooltip },
      }}
      title={<div className={classes.textBox}>{children}</div>}
      placement={placement}
      arrow={arrow}
    >
      <InfoOutlinedIcon fontSize={iconFontSize} color={color} />
    </Tooltip>
  );
};

export { InfoTooltip, InfoTooltipProps };
